import { ReactElement } from 'react';

import { useFormController } from '@dreryk/react-common';
import {
   FileUpload,
   FileUploadTriggerVariant,
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
} from '@dreryk/react-components';

import {
   onlinePaymentsIntegrationTranslationKeys,
   onlinePaymentsProviderDetailsTranslationKeys,
} from '../../translations';

import {
   ACCEPTED_PDF_FILE_EXTENSIONS,
   MAX_PDF_FILE_NAME_CHARACTERS,
   MAX_PDF_FILE_SIZE_IN_BYTES,
   VALIDATION_RULES,
} from './OnlinePaymentsIntegrationForm.constants';
import { OnlinePaymentsUpdateTermsOfServiceDocumentFormBean } from './OnlinePaymentsUpdateTermsOfServiceDocumentModal.types';
import { OnlinePaymentsTermsOfServiceUpdateAction } from './OnlinePaymentsUpdateTermsOfServiceDocumentModal.actions';

type OnlinePaymentsUpdateTermsOfServiceDocumentModalProps = {
   readonly onCancel: VoidFunction;
};

export const OnlinePaymentsUpdateTermsOfServiceDocumentModal = (
   props: OnlinePaymentsUpdateTermsOfServiceDocumentModalProps
): ReactElement => {
   const { register, handleSubmit } = useFormController<OnlinePaymentsUpdateTermsOfServiceDocumentFormBean>({});

   return (
      <Modal
         testId={'onlinePaymentsUpdateTermsOfServiceDocumentModal'}
         title={onlinePaymentsProviderDetailsTranslationKeys.updateTermsOfServiceDocumentModal.title}
         width={ModalWidth.NORMAL}
      >
         <FileUpload
            controller={register('termsOfService', VALIDATION_RULES)}
            label={onlinePaymentsIntegrationTranslationKeys.form.fields.termsOfService.label}
            triggerLabel={onlinePaymentsIntegrationTranslationKeys.form.fields.termsOfService.chooseFile}
            acceptedExtensions={ACCEPTED_PDF_FILE_EXTENSIONS}
            triggerVariant={FileUploadTriggerVariant.BUTTON_SECONDARY}
            maxFileSizeInBytes={MAX_PDF_FILE_SIZE_IN_BYTES}
            maxFileNameLength={MAX_PDF_FILE_NAME_CHARACTERS}
            placeholder={onlinePaymentsIntegrationTranslationKeys.form.fields.termsOfService.choosePdfFile}
            testId={'termsOfService'}
         >
            <FileUpload.Dropzone testId={'termsOfService'} hideIfFilled />
         </FileUpload>
         <OnlinePaymentsTermsOfServiceUpdateAction handleSubmit={handleSubmit} onSuccess={props.onCancel}>
            {({ updateTermsOfService }) => (
               <ModalConfirmButton
                  label={
                     onlinePaymentsProviderDetailsTranslationKeys.updateTermsOfServiceDocumentModal.actions.saveDocument
                        .buttonLabel
                  }
                  onClick={updateTermsOfService}
               />
            )}
         </OnlinePaymentsTermsOfServiceUpdateAction>
         <ModalCancelButton onClick={props.onCancel} />
         <ModalCloseButton onClick={props.onCancel} />
      </Modal>
   );
};
